import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    name,
    desc,
    form = {},
    list = {},
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.project.save, {
        id,
        name,
        desc,
        form,
        list,
    }, options);
    if (error) return { error, status };
    return content || {};
};

